import  { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

// ACCOUNT CREATE FUNCTION 
const SuccessfulComponent = () => {
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [timer, setTimer] = useState(5); // Initial timer value
  const loading = false;
  useEffect(() => {
    let countdown = 0;
    if (isResendDisabled) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [isResendDisabled]);

  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const roles = queryParams.get('roles');

// GOBACK FUNCTION 
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate("/login?roles=employee");
    }, 5000); // 5 seconds delay

    return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
  }, [navigate, roles]);

  return (
    <div className="SinginFormRight">
      {loading && (
        <div className="SiginLoader">
          <Spin spinning />
        </div>
      )}
      <a onClick={handleGoBack} >
        <img src={require('../../assets/images/Logo Blue TM.png')} className="SinginFormLogo" alt="" />
      </a>
      <div className="SinginFormTitleContainer">
        <h1 className='title'>Congratulations! Your account has been successfully created.</h1>
        <p className='sub-title'>
          To get started, use your mobile number to log in and begin exploring part-time job opportunities.
          <Link to={"/login?roles=employee"}> Click here to Login.</Link>
        </p>
        <p className='sub-title'>You will be redirected to the login page in {timer} seconds...</p>
      </div>
    </div>
  );
}

export default SuccessfulComponent;
